var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgService(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9267_63867)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.3892 14.7067L46.2739 6.59141L55.4051 0L60.9806 5.57549L54.3892 14.7067Z",
    fill: "#4FC6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2738 6.59143L54.3891 14.7067L49.1885 17.3675L43.613 11.792L46.2738 6.59143Z",
    fill: "#4FC6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.6126 11.7953L31.3149 24.093L36.8908 29.6688L49.1884 17.3712L43.6126 11.7953Z",
    fill: "#4FC6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.915 51.3404L9.63989 36.0774L23.5 22.2173H32.1595L38.7751 28.8208V37.4803L24.915 51.3404Z",
    fill: "#E34A4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2435 60L0.980469 44.7369L14.8406 30.8768H23.5001L30.1036 37.4803V46.1399L16.2435 60Z",
    fill: "#9E071E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5009 22.2097L5.31104 40.3996L20.5762 55.6647L38.7661 37.4748L23.5009 22.2097Z",
    fill: "#C53437"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9267_63867"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white",
    transform: "translate(0.980469)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgService);
export default __webpack_public_path__ + "static/media/service.5571c5a53ba6f0805cb46b09af3728f9.svg";
export { ForwardRef as ReactComponent };